/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Faq_A1Inputs */

const en_pc_online_faq_a1 = /** @type {(inputs: Pc_Online_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. It is the open-source PdfCraft web build (MIT or Apache-2.0), with no account, no sign-in and no usage limits from us.`)
};

const zh_pc_online_faq_a1 = /** @type {(inputs: Pc_Online_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费。它就是开源的 PdfCraft 网页版（MIT 或 Apache-2.0），本站不要求账号、无需登录，也不设使用限制。`)
};

/**
* | output |
* | --- |
* | "Yes. It is the open-source PdfCraft web build (MIT or Apache-2.0), with no account, no sign-in and no usage limits from us." |
*
* @param {Pc_Online_Faq_A1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_faq_a1 = /** @type {((inputs?: Pc_Online_Faq_A1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Faq_A1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_faq_a1(inputs)
	return zh_pc_online_faq_a1(inputs)
});
export { pc_online_faq_a1 as "pc.online.faq.a1" }